export default "__VITE_ASSET__D4k9yANc__"